import InputForm from "./input-form";

export default InputForm